precision highp float;

uniform float uTime;
uniform float uSeed;
uniform sampler2D uTexture;

varying vec2 vUv;
varying float vPos;

#pragma glslify: cnoise3 = require(glsl-noise/classic/3d)

float smoothness = .1;

float random(vec2 co) {
  float a = uSeed;
  float b = 78.233;
  float c = 43758.5453;
  float dt= dot(co.xy ,vec2(a,b));
  float sn= mod(dt,3.14);
  return fract(sin(sn) * c);
}

float noise (in vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);
    float a = random(i);
    float b = random(i + vec2(1.0, 0.0));
    float c = random(i + vec2(0.0, 1.0));
    float d = random(i + vec2(1.0, 1.0));
    vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(a, b, u.x) + (c - a)* u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

void main () {
  vec4 fromColor = texture2D(uTexture, vUv);
  vec4 toColor = vec4(0.0, 0.0, 0.0, 0.0);
  float n = noise(vUv * 2.5);

  float p = mix(-smoothness, 1.0 + smoothness, uTime);
  float lower = p - smoothness;
  float higher = p + smoothness;

  float q = smoothstep(higher, lower, n);

  gl_FragColor = mix(fromColor, toColor, 1.0 - q);
	gl_FragColor.rgb *= 1.0 - smoothstep(1.0, -4.0, vPos);
}


// void main() {
// 	vec4 tex = texture2D(uTexture, vUv);


// 	float noise = cnoise3(tex.rgb, 10.);


// 	vec3 color = vec3(tex.rgb, mix(tex.a, 0.0, uTime)


// 	gl_FragColor = tex;
// }
